export const SERVICE_TITAN_API_PATH_PREFIX = "servicetitan://api/";

export function isServiceTitanApiImport(
  filePath: string | null | undefined,
): filePath is string {
  return !!filePath?.startsWith(SERVICE_TITAN_API_PATH_PREFIX);
}
